import { Suspense } from 'react';
import { css } from '@emotion/react';
import { Loader } from '@hotjar/hotsauce';

import { SiteSettingsPage as SiteSettingsComponent } from './SiteSettingsPage';

const SiteSettingsPage = (): JSX.Element => {
  return (
    <Suspense
      fallback={
        <Loader
          css={css`
            margin-top: 65px;
          `}
        />
      }
    >
      <SiteSettingsComponent />
    </Suspense>
  );
};

// FIXME: import/no-default-export
// eslint-disable-next-line import/no-default-export
export default SiteSettingsPage;
